import _typeof from '@babel/runtime/helpers/typeof';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _assertThisInitialized from '@babel/runtime/helpers/assertThisInitialized';
import _inherits from '@babel/runtime/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/getPrototypeOf';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import React__default, { Component } from 'react';
import styled, { withTheme } from 'styled-components';
import '../components/media/Img.js';
import { Icon as Icon$1 } from '../components/media/Icon.js';
import Text from '../components/text/text.component.js';
import img$3 from '../images/button-app-store.svg.js';
import img$2 from '../images/button-play-store.svg.js';
import img$6 from '../images/logo-header-pro-contract.svg.js';
import img$5 from '../images/logo-header-pro.svg.js';
import { textColorText, textColorTextHover } from '../theme/text-theme.js';
import { t } from '../utils/utils.js';
import img$4 from './images/dropdown-arrow-language.svg.js';
import img$1 from './images/dropdown-arrow-light.svg.js';
import img from './images/dropdown-arrow.svg.js';
import img$7 from './images/young-solo.svg.js';
import img$9 from './images/YP_Step_Contratto.svg.js';
import img$8 from './images/YP_Step_Esteso.svg.js';
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
var footer_map = {
  pro: {
    logo: img$5,
    compact_logo: img$6,
    title: "header.pro",
    link: "/"
  },
  base: {
    logo: img$7,
    compact_logo: img$7,
    title: "header.base",
    link: "https://youngplatform.com"
  },
  step: {
    logo: img$8,
    compact_logo: img$9,
    title: "header.step",
    link: "https://step.youngplatform.com/",
    playStore: "https://youngplatform.page.link/XLkB",
    appleStore: "https://youngplatform.page.link/cuVF"
  }
};
var Icon = styled(Icon$1).withConfig({
  displayName: "crawlFootercomponent__Icon",
  componentId: "sc-kkesd4-0"
})(["transition:0.2s;", ""], textColorText);
var LanguageBlock = styled.div.withConfig({
  displayName: "crawlFootercomponent__LanguageBlock",
  componentId: "sc-kkesd4-1"
})(["display:flex;transition:0.2s;&:hover{& .icon-language,& p{", "}}"], textColorTextHover);
var Container = styled.div.withConfig({
  displayName: "crawlFootercomponent__Container",
  componentId: "sc-kkesd4-2"
})(["li > a > p{padding-bottom:0px;}@media screen and (max-width:768px){li > a > p{padding-bottom:17px;}}.footer-container-ui{box-sizing:border-box;}.footer-ui{padding-top:", ";padding-bottom:48px;margin-left:auto;margin-right:auto;width:100%;padding-left:24px;padding-right:24px;max-width:1188px;box-sizing:border-box;border-top:1px solid ", ";}.footer-slim-ui{padding-top:", ";padding-bottom:56px;margin-left:auto;margin-right:auto;width:calc(100vw - 280px);max-width:1140px;}.link-list > div > div > p{font-size:16px;line-height:20px;font-weight:bold;}.link-list > div ul li{font-size:14px;line-height:18px;}.link-list > div ul li a p{color:#65676b !important;}@media screen and (max-width:768px){.footer-ui{padding-top:48px;}}.container-ui{width:100%;height:auto;margin-left:auto;margin-right:auto;align-items:center;justify-content:center;flex-direction:column;}.landing-footer-container-slim-ui{display:flex;justify-content:start;padding-bottom:70px;gap:117px;align-items:baseline;}.landing-footer-container-slim-ui > div:first-of-type{width:fit-content;flex-wrap:nowrap;white-space:nowrap;}.link-list{display:grid;width:100%;row-gap:51px;grid-template-columns:auto auto auto;justify-content:space-between;grid-template-rows:auto auto;}.link-list > div{flex-direction:column;align-items:flex-start;}.link-list > div:nth-child(3n){justify-self:flex-start;}.link-list > div:first-of-type,.link-list > div:nth-child(4){justify-self:flex-start;}#menu_download li{display:flex;flex-direction:column;gap:7px;margin-top:31px;width:100%;}#menu_download li img{width:152px;object-fit:cover;}.landing-footer-container-slim-ui:last-of-type{padding-top:20px;padding-bottom:24px;display:flex;justify-content:space-between;}.last-copyright-text-ui{font-family:EuclidCircularA-Regular,Arial;font-weight:400;font-size:12px;color:#c4c4c7;margin-right:auto;display:block;max-width:950px;}.social-ui{display:flex;flex-direction:row !important;justify-content:center;}.social-ui > img{height:30px;padding-bottom:13px;padding-right:34px;cursor:pointer;}.copyright-text-ui{font-family:EuclidCircularA-Medium,Arial;font-weight:500 !important;line-height:20px !important;font-size:14px;color:var(--white) !important;margin-right:auto;display:block;}.footer-title-ui{text-transform:capitalize;}.dropdown-header-ui{display:flex;border-bottom:none;cursor:default;width:auto;}.dropdown-arrow-ui{display:none;margin-left:auto;}ul{list-style:none;padding-inline-start:0px;}@media screen and (max-width:1200px){.show-tablet-footer-ui{display:block !important;}.hide-tablet-footer-ui{display:none !important;}.last-copyright-text-ui{max-width:80vw;}.social-ui{justify-content:flex-end;}}@media screen and (max-width:768px){.show-menu-mobile{display:inline !important;}.reverse-mobile-ui{flex-direction:column-reverse !important;}.block-link-ui{padding-bottom:24px;}.block-copyright-ui{}.language-block-ui{padding-bottom:", ";}.landing-footer-container-slim-ui{flex-direction:column;}.link-list{row-gap:0px !important;column-gap:51px;grid-template-columns:1fr 1fr;justify-content:center;justify-items:center;grid-template-rows:auto;width:calc(100% - 24px);margin:auto;}.link-list > div{flex-direction:column;width:100%;}.landing-footer-container-slim-ui > div{align-items:flex-start;width:100% !important;}.footer-title-ui{padding-bottom:18px;padding-top:18px;}.landing-footer-container-slim-ui:last-of-type{border-top:none;border-bottom:none;justify-content:none !important;row-gap:0px !important;padding-bottom:16px;padding-top:0px;margin-bottom:0px;}.social-ui{justify-content:flex-start;padding-bottom:10px;padding-top:40px;}.social-ui > img:first-child{padding-left:0px !important;margin-left:0px !important;}.copyright-text-ui{padding-bottom:20px;}ul{display:none;}.dropdown-arrow-ui{display:inline;width:24px;height:24px;}.dropdown-header-ui{border-bottom:1px solid ", ";cursor:pointer;width:inherit;align-items:center;}}@media screen and (max-width:590px){.link-list{grid-template-columns:1fr;}}"], function (props) {
  return props.isMobile ? "48px" : "96px";
}, function (props) {
  return props.theme == "dark" ? "#2C2C2D" : "#E2E3E4";
}, function (props) {
  return props.isMobile ? "48px" : "96px";
}, function (props) {
  return props.slim ? "0" : "48px";
}, function (props) {
  return props.theme == "dark" ? "var(--dark-gray-5)" : "var(--light-gray-5)";
});
var TextFooterInfo = styled(Text).withConfig({
  displayName: "crawlFootercomponent__TextFooterInfo",
  componentId: "sc-kkesd4-3"
})(["@media screen and (max-width:768px){font-size:10px;line-height:16px;}"]);
var Footer = /*#__PURE__*/function (_Component) {
  _inherits(Footer, _Component);
  var _super = _createSuper(Footer);
  function Footer() {
    var _this;
    _classCallCheck(this, Footer);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "toggleDropdown", function (ul_key) {
      var ul_key = ul_key.replace("dropdown-", "");
      var ul = document.getElementById("menu_" + ul_key);
      var arrow = document.getElementById("arrow_" + ul_key);
      if (arrow.style.display != "none") {
        if (ul.classList.contains("show-menu-mobile")) {
          ul.classList.remove("show-menu-mobile");
          arrow.style.transform = "rotate(0deg)";
        } else {
          ul.classList.add("show-menu-mobile");
          arrow.style.transform = "rotate(180deg)";
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "getLngPath", function (lng) {
      if (lng) {
        return lng === "it" ? "/" : "/en/";
      }
      return "/en/";
    });
    return _this;
  }
  _createClass(Footer, [{
    key: "trimLastSlash",
    value: function trimLastSlash(str) {
      console.log(str[str.length - 1]);
      if (str[str.length - 1] === "/") {
        return str.slice(0, -1);
      }
      return str;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2,
        _this2 = this;
      var _this$props = this.props,
        isMobile = _this$props.isMobile,
        slim = _this$props.slim,
        theme = _this$props.theme,
        languageCallback = _this$props.languageCallback,
        lng = _this$props.lng,
        staticLanguageLink = _this$props.staticLanguageLink;
      var product = this.props.product && this.props.product ? this.props.product : "base";
      var date = new Date().getFullYear();
      var lngPath = this.getLngPath(lng);
      var footerImgLink = product == "base" || "pro" ? "https://youngplatform.com" : footer_map[product].link;
      var crawlPath = ((_this$props2 = this.props) !== null && _this$props2 !== void 0 && _this$props2.crawlPath ? this.trimLastSlash(this.props.crawlPath) : "https://youngplatform.com") + lngPath;
      var isTargetBlank = function isTargetBlank() {
        var _this2$props;
        return (_this2$props = _this2.props) !== null && _this2$props !== void 0 && _this2$props.isLanding ? "_self" : "_blank";
      };
      var staticLanguageLinkHandler = (this.props.crawlPath ? this.props.crawlPath : "https://youngplatform.com") + staticLanguageLink;
      return /*#__PURE__*/React__default.createElement(Container, {
        className: "footer-container-ui",
        style: this.props.style,
        theme: theme,
        slim: slim
      }, !slim ? /*#__PURE__*/React__default.createElement("div", {
        className: slim ? "footer-slim-ui" : "footer-ui"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "show-tablet-footer-ui",
        style: {
          display: "none"
        }
      }, /*#__PURE__*/React__default.createElement("a", {
        href: footerImgLink + lngPath,
        title: "Young Platform",
        target: "_self",
        style: {
          marginBottom: isMobile ? "50px" : "40px",
          marginRight: "auto",
          textDecoration: "none",
          display: "flex"
        }
      }, /*#__PURE__*/React__default.createElement("img", {
        alt: "logo",
        className: "logo",
        style: {
          width: "fit-content",
          height: "30px"
        },
        src: footer_map[product].compact_logo
      }))), /*#__PURE__*/React__default.createElement("div", {
        className: "container-ui"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "landing-footer-container-slim-ui block-link-ui",
        style: {
          display: slim ? "none" : " "
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "hide-tablet-footer-ui"
      }, /*#__PURE__*/React__default.createElement("a", {
        href: footer_map[product].link,
        title: t(lng, footer_map[product].title),
        style: {
          marginBottom: isMobile ? "50px" : "40px",
          marginRight: "auto",
          textDecoration: "none",
          display: "flex",
          alignItems: "center",
          gap: isMobile ? "0px" : "9.5px"
        }
      }, isMobile ? /*#__PURE__*/React__default.createElement("img", {
        alt: "logo",
        className: "logo",
        style: {
          width: "fit-content",
          height: "30px"
        },
        src: footer_map[product].compact_logo
      }) : /*#__PURE__*/React__default.createElement("img", {
        alt: "logo",
        className: "logo",
        style: {
          width: "fit-content",
          height: "30px"
        },
        src: footer_map[product].logo
      }))), /*#__PURE__*/React__default.createElement("div", {
        className: "link-list"
      }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
        className: "dropdown-header-ui",
        id: "dropdown_azienda",
        onClick: function onClick() {
          _this2.toggleDropdown("azienda");
        }
      }, /*#__PURE__*/React__default.createElement(Text, {
        className: "footer-title-ui",
        fontFamily: "euclid",
        type: "label",
        fontSize: "largeB"
      }, t(lng, "landing-footer.company")), /*#__PURE__*/React__default.createElement("img", {
        className: "dropdown-arrow-ui",
        id: "arrow_azienda",
        width: "24",
        height: "24",
        src: theme.layout == "dark" ? img : img$1
      })), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("ul", {
        id: "menu_azienda"
      }, /*#__PURE__*/React__default.createElement("li", null, /*#__PURE__*/React__default.createElement("a", {
        href: crawlPath + "about/",
        title: "Chi siamo",
        target: isTargetBlank(),
        style: {
          textDecoration: "none",
          transition: "0.5s"
        }
      }, /*#__PURE__*/React__default.createElement(Text, {
        fontFamily: "euclid",
        type: "paragraph",
        fontSize: "small",
        color: "grey-1",
        hover: true,
        style: {
          paddingTop: "8px",
          paddingBottom: "8px"
        }
      }, t(lng, "landing-footer.about")))), /*#__PURE__*/React__default.createElement("li", null, /*#__PURE__*/React__default.createElement("a", {
        href: crawlPath + "jobs/",
        title: t(lng, "landing-footer.careers"),
        target: isTargetBlank(),
        style: {
          textDecoration: "none",
          transition: "0.5s"
        }
      }, /*#__PURE__*/React__default.createElement(Text, {
        fontFamily: "euclid",
        type: "paragraph",
        fontSize: "small",
        color: "grey-1",
        hover: true,
        style: {
          paddingTop: "8px",
          paddingBottom: "8px"
        }
      }, t(lng, "landing-footer.careers")))), /*#__PURE__*/React__default.createElement("li", null, /*#__PURE__*/React__default.createElement("a", {
        href: crawlPath + "why-us/",
        title: t(lng, "landing-footer.whyUs"),
        target: isTargetBlank(),
        style: {
          textDecoration: "none",
          transition: "0.5s"
        }
      }, /*#__PURE__*/React__default.createElement(Text, {
        fontFamily: "euclid",
        type: "paragraph",
        fontSize: "small",
        color: "grey-1",
        hover: true,
        style: {
          paddingTop: "8px",
          paddingBottom: "8px"
        }
      }, t(lng, "landing-footer.whyUs")))), /*#__PURE__*/React__default.createElement("li", null, /*#__PURE__*/React__default.createElement("a", {
        href: crawlPath + "talking-about-us/",
        title: t(lng, "landing-footer.talking-about-us"),
        target: isTargetBlank(),
        style: {
          textDecoration: "none",
          transition: "0.5s"
        }
      }, /*#__PURE__*/React__default.createElement(Text, {
        fontFamily: "euclid",
        type: "paragraph",
        fontSize: "small",
        color: "grey-1",
        hover: true,
        style: {
          paddingTop: "8px",
          paddingBottom: "8px"
        }
      }, t(lng, "landing-footer.talking-about-us")))), /*#__PURE__*/React__default.createElement("li", null, /*#__PURE__*/React__default.createElement("a", {
        href: "https://storage.googleapis.com/young-documents/2019_Presskit_Smart.zip",
        title: t(lng, "landing-footer.pressKit"),
        rel: "noopener",
        style: {
          textDecoration: "none",
          transition: "0.5s"
        }
      }, /*#__PURE__*/React__default.createElement(Text, {
        fontFamily: "euclid",
        type: "paragraph",
        fontSize: "small",
        color: "grey-1",
        hover: true,
        style: {
          paddingTop: "8px",
          paddingBottom: "8px"
        }
      }, t(lng, "landing-footer.pressKit"))))))), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
        className: "dropdown-header-ui",
        id: "dropdown-products",
        onClick: function onClick() {
          _this2.toggleDropdown("products");
        }
      }, /*#__PURE__*/React__default.createElement(Text, {
        className: "footer-title-ui",
        fontFamily: "euclid",
        type: "label",
        fontSize: "largeB"
      }, t(lng, "landing-footer.product")), /*#__PURE__*/React__default.createElement("img", {
        className: "dropdown-arrow-ui",
        id: "arrow_products",
        width: "24",
        height: "24",
        src: theme.layout == "dark" ? img : img$1
      })), /*#__PURE__*/React__default.createElement("ul", {
        id: "menu_products"
      }, /*#__PURE__*/React__default.createElement("li", null, /*#__PURE__*/React__default.createElement("a", {
        href: "https://exchange.youngplatform.com/",
        rel: "noopener",
        title: "young platform",
        style: {
          textDecoration: "none",
          transition: "0.5s"
        }
      }, /*#__PURE__*/React__default.createElement(Text, {
        fontFamily: "euclid",
        type: "paragraph",
        fontSize: "small",
        color: "grey-1",
        hover: true,
        style: {
          paddingTop: "8px",
          paddingBottom: "8px"
        }
      }, "Young Platform"))), /*#__PURE__*/React__default.createElement("li", {
        onClick: function onClick() {
          window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
          });
        }
      }, /*#__PURE__*/React__default.createElement("a", {
        title: "young platform pro",
        href: "https://pro.youngplatform.com",
        rel: "noopener",
        style: {
          textDecoration: "none",
          cursor: "pointer",
          transition: "0.5s"
        }
      }, /*#__PURE__*/React__default.createElement(Text, {
        fontFamily: "euclid",
        type: "paragraph",
        fontSize: "small",
        color: "grey-1",
        hover: true,
        style: {
          paddingTop: "8px",
          paddingBottom: "8px"
        }
      }, "Young Platform Pro"))), /*#__PURE__*/React__default.createElement("li", null, /*#__PURE__*/React__default.createElement("a", {
        title: "step",
        rel: "noopener",
        href: "https://step.youngplatform.com",
        style: {
          textDecoration: "none",
          transition: "0.5s"
        }
      }, /*#__PURE__*/React__default.createElement(Text, {
        fontFamily: "euclid",
        type: "paragraph",
        fontSize: "small",
        color: "grey-1",
        hover: true,
        style: {
          paddingTop: "8px",
          paddingBottom: "8px"
        }
      }, "Young Platform Step"))), /*#__PURE__*/React__default.createElement("li", null, /*#__PURE__*/React__default.createElement("a", {
        href: "https://academy.youngplatform.com" + lngPath,
        target: "_blank",
        rel: "noopener",
        title: "academy",
        style: {
          textDecoration: "none",
          transition: "0.5s"
        }
      }, /*#__PURE__*/React__default.createElement(Text, {
        fontFamily: "euclid",
        type: "paragraph",
        fontSize: "small",
        color: "grey-1",
        hover: true,
        style: {
          paddingTop: "8px",
          paddingBottom: "8px"
        }
      }, "Young Platform Academy"))))), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
        className: "dropdown-header-ui",
        id: "dropdown-support",
        onClick: function onClick() {
          _this2.toggleDropdown("support");
        }
      }, /*#__PURE__*/React__default.createElement(Text, {
        className: "footer-title-ui",
        fontFamily: "euclid",
        type: "label",
        fontSize: "largeB",
        hover: true
      }, t(lng, "landing-footer.support")), /*#__PURE__*/React__default.createElement("img", {
        className: "dropdown-arrow-ui",
        id: "arrow_support",
        width: "24",
        height: "24",
        src: theme.layout == "dark" ? img : img$1
      })), /*#__PURE__*/React__default.createElement("ul", {
        id: "menu_support"
      }, /*#__PURE__*/React__default.createElement("li", null, /*#__PURE__*/React__default.createElement("a", {
        href: "https://support.youngplatform.com/",
        target: "_blank",
        rel: "noopener",
        title: t(lng, "landing-footer.service_center"),
        style: {
          textDecoration: "none",
          transition: "0.5s"
        }
      }, /*#__PURE__*/React__default.createElement(Text, {
        fontFamily: "euclid",
        type: "paragraph",
        fontSize: "small",
        color: "grey-1",
        hover: true,
        style: {
          paddingTop: "8px",
          paddingBottom: "8px"
        }
      }, t(lng, "landing-footer.service_center")))), /*#__PURE__*/React__default.createElement("li", null, /*#__PURE__*/React__default.createElement("a", {
        href: crawlPath + "glossary/",
        target: isTargetBlank(),
        title: t(lng, "landing-footer.glossary"),
        style: {
          textDecoration: "none",
          transition: "0.5s"
        }
      }, /*#__PURE__*/React__default.createElement(Text, {
        fontFamily: "euclid",
        type: "paragraph",
        fontSize: "small",
        color: "grey-1",
        hover: true,
        style: {
          paddingTop: "8px",
          paddingBottom: "8px"
        }
      }, t(lng, "landing-footer.glossary")))), /*#__PURE__*/React__default.createElement("li", null, /*#__PURE__*/React__default.createElement("a", {
        href: "".concat(crawlPath, "faq/taxation/"),
        target: isTargetBlank(),
        title: t(lng, "landing-footer.faq_1"),
        style: {
          textDecoration: "none",
          transition: "0.5s"
        }
      }, /*#__PURE__*/React__default.createElement(Text, {
        fontFamily: "euclid",
        type: "paragraph",
        fontSize: "small",
        color: "grey-1",
        hover: true,
        style: {
          paddingTop: "8px",
          paddingBottom: "8px"
        }
      }, t(lng, "landing-footer.faq_1")))), /*#__PURE__*/React__default.createElement("li", null, /*#__PURE__*/React__default.createElement("a", {
        href: "".concat(crawlPath, "faq/exchange/"),
        target: isTargetBlank(),
        title: t(lng, "landing-footer.faq_2"),
        style: {
          textDecoration: "none",
          transition: "0.5s"
        }
      }, /*#__PURE__*/React__default.createElement(Text, {
        fontFamily: "euclid",
        type: "paragraph",
        fontSize: "small",
        color: "grey-1",
        hover: true,
        style: {
          paddingTop: "8px",
          paddingBottom: "8px"
        }
      }, t(lng, "landing-footer.faq_2")))), /*#__PURE__*/React__default.createElement("li", null, /*#__PURE__*/React__default.createElement("a", {
        href: "".concat(crawlPath, "faq/fees/"),
        target: isTargetBlank(),
        title: t(lng, "landing-footer.faq_3"),
        style: {
          textDecoration: "none",
          transition: "0.5s"
        }
      }, /*#__PURE__*/React__default.createElement(Text, {
        fontFamily: "euclid",
        type: "paragraph",
        fontSize: "small",
        color: "grey-1",
        hover: true,
        style: {
          paddingTop: "8px",
          paddingBottom: "8px"
        }
      }, t(lng, "landing-footer.faq_3")))))), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
        className: "dropdown-header-ui",
        id: "dropdown-products",
        onClick: function onClick() {
          _this2.toggleDropdown("learn");
        }
      }, /*#__PURE__*/React__default.createElement(Text, {
        className: "footer-title-ui",
        fontFamily: "euclid",
        type: "label",
        fontSize: "largeB"
      }, t(lng, "landing-footer.learn")), /*#__PURE__*/React__default.createElement("img", {
        className: "dropdown-arrow-ui",
        id: "arrow_learn",
        width: "24",
        height: "24",
        src: theme.layout == "dark" ? img : img$1
      })), /*#__PURE__*/React__default.createElement("ul", {
        id: "menu_learn"
      }, /*#__PURE__*/React__default.createElement("li", null, /*#__PURE__*/React__default.createElement("a", {
        href: lng && lng.toLowerCase() === "it" ? "https://academy.youngplatform.com/it/principiante/articoli/tutti/come-comprare-bitcoin-in-5-mosse" : "https://academy.youngplatform.com/en/beginner/articles/everything/how-to-buy-bitcoin-in-5-steps",
        target: "_blank",
        rel: "noopener",
        title: t(lng, "landing-footer.learn1"),
        style: {
          textDecoration: "none",
          transition: "0.5s"
        }
      }, /*#__PURE__*/React__default.createElement(Text, {
        fontFamily: "euclid",
        type: "paragraph",
        fontSize: "small",
        color: "grey-1",
        hover: true,
        style: {
          paddingTop: "8px",
          paddingBottom: "8px"
        }
      }, t(lng, "landing-footer.learn1")))), /*#__PURE__*/React__default.createElement("li", null, /*#__PURE__*/React__default.createElement("a", {
        title: t(lng, "landing-footer.learn2"),
        href: lng && lng.toLowerCase() === "it" ? "https://academy.youngplatform.com/it/principiante/articoli/tutti/bitcoin-come-iniziare-guida-per-principianti" : "https://academy.youngplatform.com/en/beginner/articles/everything/bitcoin-ultimate-guide-beginners",
        target: "_blank",
        rel: "noopener",
        style: {
          textDecoration: "none",
          transition: "0.5s"
        }
      }, /*#__PURE__*/React__default.createElement(Text, {
        fontFamily: "euclid",
        type: "paragraph",
        fontSize: "small",
        color: "grey-1",
        hover: true,
        style: {
          paddingTop: "8px",
          paddingBottom: "8px"
        }
      }, t(lng, "landing-footer.learn2")))), /*#__PURE__*/React__default.createElement("li", null, /*#__PURE__*/React__default.createElement("a", {
        href: lng && lng.toLowerCase() === "it" ? "https://academy.youngplatform.com/it/intermedio/articoli-intermedio/criptovalute-articoli-intermedio/guadagna-bat-brave-browser" : "https://academy.youngplatform.com/en/intermediate/articles-intermediate/cryptocurrency-articles-intermediate",
        target: "_blank",
        rel: "noopener",
        title: t(lng, "landing-footer.learn3"),
        style: {
          textDecoration: "none",
          transition: "0.5s"
        }
      }, /*#__PURE__*/React__default.createElement(Text, {
        fontFamily: "euclid",
        type: "paragraph",
        fontSize: "small",
        color: "grey-1",
        hover: true,
        style: {
          paddingTop: "8px",
          paddingBottom: "8px"
        }
      }, t(lng, "landing-footer.learn3")))), /*#__PURE__*/React__default.createElement("li", null, /*#__PURE__*/React__default.createElement("a", {
        href: crawlPath + "exchange/btc/",
        title: t(lng, "landing-footer.buy1"),
        target: isTargetBlank(),
        style: {
          textDecoration: "none",
          transition: "0.5s"
        }
      }, /*#__PURE__*/React__default.createElement(Text, {
        fontFamily: "euclid",
        type: "paragraph",
        fontSize: "small",
        color: "grey-1",
        hover: true,
        style: {
          paddingTop: "8px",
          paddingBottom: "8px"
        }
      }, t(lng, "landing-footer.buy1")))), /*#__PURE__*/React__default.createElement("li", null, /*#__PURE__*/React__default.createElement("a", {
        href: crawlPath + "exchange/eth/",
        title: t(lng, "landing-footer.buy2"),
        target: isTargetBlank(),
        style: {
          textDecoration: "none",
          transition: "0.5s"
        }
      }, /*#__PURE__*/React__default.createElement(Text, {
        fontFamily: "euclid",
        type: "paragraph",
        fontSize: "small",
        color: "grey-1",
        hover: true,
        style: {
          paddingTop: "8px",
          paddingBottom: "8px"
        }
      }, t(lng, "landing-footer.buy2")))), /*#__PURE__*/React__default.createElement("li", null, /*#__PURE__*/React__default.createElement("a", {
        href: crawlPath + "exchange/dot/",
        title: t(lng, "landing-footer.buy3"),
        target: isTargetBlank(),
        style: {
          textDecoration: "none",
          transition: "0.5s"
        }
      }, /*#__PURE__*/React__default.createElement(Text, {
        fontFamily: "euclid",
        type: "paragraph",
        fontSize: "small",
        color: "grey-1",
        hover: true,
        style: {
          paddingTop: "8px",
          paddingBottom: "8px"
        }
      }, t(lng, "landing-footer.buy3")))))), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
        className: "dropdown-header-ui",
        id: "dropdown-conditions",
        onClick: function onClick() {
          _this2.toggleDropdown("conditions");
        }
      }, /*#__PURE__*/React__default.createElement(Text, {
        className: "footer-title-ui",
        fontFamily: "euclid",
        type: "label",
        fontSize: "largeB",
        hover: true
      }, t(lng, "landing-footer.conditions")), /*#__PURE__*/React__default.createElement("img", {
        className: "dropdown-arrow-ui",
        id: "arrow_conditions",
        width: "24",
        height: "24",
        src: theme.layout == "dark" ? img : img$1
      })), /*#__PURE__*/React__default.createElement("ul", {
        id: "menu_conditions"
      }, /*#__PURE__*/React__default.createElement("li", null, /*#__PURE__*/React__default.createElement("a", {
        href: theme.layout == "dark" ? "/fees" : "https://exchange.youngplatform.com/fees",
        target: "_blank",
        rel: "noopener",
        title: t(lng, "landing-footer.commission_price"),
        style: {
          textDecoration: "none",
          transition: "0.5s"
        }
      }, /*#__PURE__*/React__default.createElement(Text, {
        fontFamily: "euclid",
        type: "paragraph",
        fontSize: "small",
        color: "grey-1",
        hover: true,
        style: {
          paddingTop: "8px",
          paddingBottom: "8px"
        }
      }, t(lng, "landing-footer.commission_price")))), /*#__PURE__*/React__default.createElement("li", null, /*#__PURE__*/React__default.createElement("a", {
        href: "https://exchange.youngplatform.com/privacy_policy",
        target: "_blank",
        rel: "noopener",
        title: "privacy policy",
        style: {
          textDecoration: "none",
          transition: "0.5s"
        }
      }, /*#__PURE__*/React__default.createElement(Text, {
        fontFamily: "euclid",
        type: "paragraph",
        fontSize: "small",
        color: "grey-1",
        hover: true,
        style: {
          paddingTop: "8px",
          paddingBottom: "8px"
        }
      }, "Privacy Policy"))), /*#__PURE__*/React__default.createElement("li", null, /*#__PURE__*/React__default.createElement("a", {
        href: "https://exchange.youngplatform.com/aml",
        target: "_blank",
        rel: "noopener",
        title: "aml policy",
        style: {
          textDecoration: "none",
          transition: "0.5s"
        }
      }, /*#__PURE__*/React__default.createElement(Text, {
        fontFamily: "euclid",
        type: "paragraph",
        fontSize: "small",
        color: "grey-1",
        hover: true,
        style: {
          paddingTop: "8px",
          paddingBottom: "8px"
        }
      }, "AML Policy"))), /*#__PURE__*/React__default.createElement("li", null, /*#__PURE__*/React__default.createElement("a", {
        href: "https://exchange.youngplatform.com/terms_and_conditions",
        target: "_blank",
        rel: "noopener",
        title: t(lng, "landing-footer.footer_terms"),
        style: {
          textDecoration: "none",
          transition: "0.5s"
        }
      }, /*#__PURE__*/React__default.createElement(Text, {
        fontFamily: "euclid",
        type: "paragraph",
        fontSize: "small",
        color: "grey-1",
        hover: true,
        style: {
          paddingTop: "8px",
          paddingBottom: "8px"
        }
      }, t(lng, "landing-footer.footer_terms")))), product == "step" ? /*#__PURE__*/React__default.createElement("li", null, /*#__PURE__*/React__default.createElement("a", {
        href: "https://step.youngplatform.com/terms-and-conditions",
        target: "_blank",
        rel: "noopener",
        title: t(lng, "landing-footer.footer_terms_step"),
        style: {
          textDecoration: "none",
          transition: "0.5s"
        }
      }, /*#__PURE__*/React__default.createElement(Text, {
        fontFamily: "euclid",
        type: "paragraph",
        fontSize: "small",
        color: "grey-1",
        hover: true,
        style: {
          paddingTop: "8px",
          paddingBottom: "8px"
        }
      }, t(lng, "landing-footer.footer_terms_step")))) : "", /*#__PURE__*/React__default.createElement("li", null, /*#__PURE__*/React__default.createElement("a", {
        href: "https://exchange.youngplatform.com/refund_policy",
        target: "_blank",
        rel: "noopener",
        title: t(lng, "landing-footer.refund_policy"),
        style: {
          textDecoration: "none",
          transition: "0.5s"
        }
      }, /*#__PURE__*/React__default.createElement(Text, {
        fontFamily: "euclid",
        type: "paragraph",
        fontSize: "small",
        color: "grey-1",
        hover: true,
        style: {
          paddingTop: "8px",
          paddingBottom: "8px"
        }
      }, t(lng, "landing-footer.refund_policy")))))), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
        className: "dropdown-header-ui",
        id: "dropdown-download",
        onClick: function onClick() {
          _this2.toggleDropdown("download");
        }
      }, /*#__PURE__*/React__default.createElement(Text, {
        className: "footer-title-ui",
        fontFamily: "euclid",
        type: "label",
        fontSize: "largeB",
        hover: true
      }, t(lng, "landing-footer.download")), /*#__PURE__*/React__default.createElement("img", {
        className: "dropdown-arrow-ui",
        id: "arrow_download",
        width: "24",
        height: "24",
        src: theme.layout == "dark" ? img : img$1
      })), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("ul", {
        id: "menu_download"
      }, /*#__PURE__*/React__default.createElement("li", null, /*#__PURE__*/React__default.createElement("a", {
        href: !((product === "pro" || product === "base") && _typeof(product) !== undefined) ? footer_map[product].playStore : "https://youngexchange.page.link/dr8x",
        onClick: null,
        style: {
          cursor: "pointer"
        }
      }, /*#__PURE__*/React__default.createElement("img", {
        src: img$2,
        alt: "Download from play store",
        width: "152",
        height: "45"
      })), /*#__PURE__*/React__default.createElement("a", {
        href: !((product === "pro" || product === "base") && _typeof(product) !== undefined) ? footer_map[product].appleStore : "https://youngexchange.page.link/sBwZ",
        onClick: null,
        style: {
          cursor: "pointer"
        }
      }, /*#__PURE__*/React__default.createElement("img", {
        src: img$3,
        width: "152",
        height: "45",
        alt: "Download from app store"
      })))))))), /*#__PURE__*/React__default.createElement("div", {
        className: "landing-footer-container-slim-ui reverse-mobile-ui"
      }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Text, {
        fontFamily: "euclid",
        type: "paragraph",
        fontSize: "small",
        color: "grey-1"
      }, "©" + date + " " + t(lng, "copyright"))), /*#__PURE__*/React__default.createElement(LanguageBlock, {
        color: "grey-1",
        className: "language-block-ui"
      }, /*#__PURE__*/React__default.createElement("a", {
        href: staticLanguageLink ? staticLanguageLinkHandler : null,
        onClick: !staticLanguageLink && languageCallback ? function () {
          return languageCallback();
        } : null,
        style: {
          textDecoration: "none",
          cursor: "pointer",
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }
      }, /*#__PURE__*/React__default.createElement(Icon, {
        className: "icon-language",
        icon: "global",
        color: "grey-1",
        fontSize: "20px",
        style: {
          marginRight: "8px"
        }
      }), /*#__PURE__*/React__default.createElement(Text, {
        fontFamily: "euclid",
        type: "label",
        fontSize: "small",
        color: "grey-1"
      }, !isMobile ? t(lng, "landing-footer.language") + ":" + " " + t(lng, "landing-footer." + lng) : t(lng, "landing-footer." + lng)), /*#__PURE__*/React__default.createElement("img", {
        src: img$4,
        style: {
          marginLeft: "14px",
          display: "none"
        }
      }))), /*#__PURE__*/React__default.createElement("div", {
        className: "hide-tablet-footer-ui"
      }), /*#__PURE__*/React__default.createElement("div", {
        className: "hide-tablet-footer-ui"
      }))), /*#__PURE__*/React__default.createElement(TextFooterInfo, {
        fontFamily: "euclid",
        type: "paragraph",
        fontSize: "xsmall",
        color: "grey-1"
      }, t(lng, "landing-footer.sub_copyright"))) : /*#__PURE__*/React__default.createElement("div", {
        style: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          paddingBottom: "34px"
        }
      }, /*#__PURE__*/React__default.createElement("a", {
        href: "https://exchange.youngplatform.com/terms_and_conditions",
        rel: "noopener",
        style: {
          marginRight: "24px",
          textDecoration: "none"
        }
      }, /*#__PURE__*/React__default.createElement(Text, {
        fontFamily: "euclid",
        type: "label",
        fontSize: "small",
        hover: true,
        color: "grey-1"
      }, t(lng, "landing-footer.footer_terms"))), /*#__PURE__*/React__default.createElement("a", {
        href: "https://support.youngplatform.com/",
        rel: "noopener",
        style: {
          marginRight: "24px",
          textDecoration: "none"
        }
      }, /*#__PURE__*/React__default.createElement(Text, {
        fontFamily: "euclid",
        type: "label",
        fontSize: "small",
        hover: true,
        color: "grey-1"
      }, t(lng, "landing-footer.contact_us"))), /*#__PURE__*/React__default.createElement(LanguageBlock, {
        color: "grey-1",
        className: "language-block-ui"
      }, /*#__PURE__*/React__default.createElement("div", {
        onClick: languageCallback ? function () {
          return languageCallback();
        } : null,
        style: {
          cursor: "pointer",
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }
      }, /*#__PURE__*/React__default.createElement(Icon, {
        className: "icon-language",
        icon: "global",
        color: "grey-1",
        fontSize: "20px",
        style: {
          marginRight: "8px"
        }
      }), /*#__PURE__*/React__default.createElement(Text, {
        fontFamily: "euclid",
        type: "label",
        fontSize: "small",
        color: "grey-1"
      }, !isMobile ? t(lng, "landing-footer.language") + ":" + " " + t(lng, "landing-footer." + lng) : t(lng, "landing-footer." + lng)), /*#__PURE__*/React__default.createElement("img", {
        src: img$4,
        style: {
          marginLeft: "14px",
          display: "none"
        }
      })))));
    }
  }]);
  return Footer;
}(Component);
var crawlFooter_component = withTheme(Footer);
export { crawlFooter_component as default };